function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8Instagram1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "500px",
    height: "500px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fbfbff",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M16,46h18c6.627,0,12-5.373,12-12V16c0-6.627-5.373-12-12-12H16C9.373,4,4,9.373,4,16v18C4,40.627,9.373,46,16,46z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#fbfbff",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    cx: 25,
    cy: 25,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fbfbff"
    },
    cx: 37,
    cy: 13,
    r: 2
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Instagram1);
export default __webpack_public_path__ + "static/media/icons8-instagram(1).cb8b09d50076af2385742c0395baee67.svg";
export { ForwardRef as ReactComponent };